import {intlShape, RemoveButton, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import {animated} from 'react-spring';

import styles from './SelectedFilterNode.less';
import {Filter, FilterUtils} from 'src/js/lib/filtering';
import {FilterSchema} from 'src/js/model/filters_config';
// import SelectedFilterNodeNegation from './SelectedFilterNodeNegation';

const I18N = defineMessages({
  REMOVE: {
    id: 'filter.selectedFilters.remove.title',
    defaultMessage: 'Remove filter',
    description: 'title text for remove filter button in selected filters box',
  },
});

class SelectedFilterNode extends React.PureComponent {
  getNode() {
    const {filter, schema} = this.props;
    return schema.getFilterByName(filter.getProperty());
  }

  isNotRemovable() {
    const node = this.getNode();
    return !!node.isNotRemovable();
  }

  render() {
    const {
      agens,
      animatedStyle,
      autocompleteValues,
      enumMap,
      filter,
      hierarchyChildrenLabels,
      intl,
      organizations,
      removeFilter,
      schema,
      showOperatorAfter,
    } = this.props;

    const componentString = FilterUtils.filterToComponentString(
      filter,
      schema,
      intl,
      {
        hierarchyChildrenLabels,
        autocompleteValues,
        enumMap,
        organizations,
        agens,
      }
    );

    return (
      <animated.div
        className={styles.dlSelectedFilterNodeWrap}
        style={animatedStyle}
        data-name={filter.getProperty()}
      >
        <div className={styles.dlSelectedFilterNodeContainer}>
          <div className={styles.dlSelectedFilterNode}>
            {/* <SelectedFilterNodeNegation /> */}
            <span
              className={styles.dlSelectedFilterNodeContent}
              title={componentString}
            >
              {componentString}
            </span>
            {!this.isNotRemovable() && (
              <RemoveButton
                item={filter}
                removeCallback={removeFilter}
                titleText={I18N.REMOVE.id}
              />
            )}
          </div>
          {showOperatorAfter ? null : (
            <span className={styles.dlFilterOperator}>AND</span>
          )}
        </div>
      </animated.div>
    );
  }
}

SelectedFilterNode.displayName = 'SelectedFilterNode';

SelectedFilterNode.propTypes = {
  agens: PropTypes.arrayOf(PropTypes.any),
  animatedStyle: PropTypes.objectOf(PropTypes.any),
  autocompleteValues: PropTypes.objectOf(PropTypes.any).isRequired,
  enumMap: PropTypes.objectOf(PropTypes.any).isRequired,
  filter: PropTypes.instanceOf(Filter).isRequired,
  hierarchyChildrenLabels: PropTypes.objectOf(PropTypes.any),
  organizations: PropTypes.arrayOf(PropTypes.any),
  schema: PropTypes.instanceOf(FilterSchema).isRequired,
  intl: intlShape.isRequired,
  removeFilter: PropTypes.func.isRequired,
  showOperatorAfter: PropTypes.bool,
};

SelectedFilterNode.defaultProps = {
  animatedStyle: null,
  hierarchyChildrenLabels: undefined,
  organizations: undefined,
  agens: undefined,
  showOperatorAfter: false,
};

export default injectIntl(SelectedFilterNode, {forwardRef: true});
